
export interface MapModel {
    address: string,
    street: string,
    state: string,
    streetNumber: number | undefined,
    postCode: string,
    city: string,
    entreCalles?: string,
    depto: string,
    coordinates: {
        lon: number,
        lat: number
    }
    //accessLocation: boolean,
}

export interface DirecGoogle {
    types: string [],
    formatted_address: string,
    address_components: AdressComponentGoogle[],
    partial_match: boolean,
    place_id: string,
    postcode_localities: string[],
    geometry: {
      location: {
        lat:number,
        lng:number,
      },
      location_type: string,
    }
}
export interface AdressComponentGoogle {
    short_name: string,
    long_name: string,
    postcode_localities: string[],
    types: string[],
}

export interface ResultGoogle {
    results: DirecGoogle[],
    status: string,
}

export interface MapConfirmationDto {
    coordinates: Coordinates,
    noneNumber: boolean,
    street: string,
    streetNumber: number,
}

export interface Coordinates {
    lon: number,
    lat: number
}

import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function zipCodeValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const zipCode = control.value;
    if (!zipCode) return null; // Si no hay valor, no valida

    // Expresión regular para formato de código postal
    const regex = /^\d{5}-\d{3}$/;
    
    // Validar que el formato sea correcto
    if (!regex.test(zipCode)) {
      return { invalidZipCodeFormat: true };
    }

    // Validar que los últimos 3 dígitos no sean "000"
    const lastThreeDigits = zipCode.slice(-3);
    if (lastThreeDigits === '000') {
      return { invalidZipCodeEnding: true };
    }

    return null; // Si pasa todas las validaciones
  };
}


